// extracted by mini-css-extract-plugin
module.exports = {"bid":"cell_bid__NtQit"};